import React, { useState } from 'react';

const AVAILABILITY = ['Available', 'Limited Stock', 'Out of Stock', 'Coming Soon'];
const OFFER_LABELS = ['', "Today's Offer", 'Festival Offer', 'Weekend Offer', 'Seasonal Offer', 'Launch Offer'];

const EMPTY = {
  category: 'General', subCategory: '', productName: '', description: '', unit: '',
  price: '', offerPrice: '', availability: 'Available', tags: '', keywords: '',
  offerStart: '', offerEnd: '', offerLabel: '',
};

const inputCls =
  'w-full bg-white/5 ring-1 ring-white/10 rounded-xl px-3 py-2 text-sm text-white placeholder-white/30 ' +
  'focus:outline-none focus:ring-2 focus:ring-emerald-500 transition';
const labelCls = 'flex flex-col gap-1.5 text-[11px] font-semibold uppercase tracking-widest text-white/40';

export default function MiniERPPriceFlowProductForm({ initial, onSave, onClose }) {
  const [form, setForm] = useState(() =>
    initial
      ? {
          ...EMPTY,
          ...initial,
          tags: (initial.tags || []).join(', '),
          keywords: (initial.keywords || []).join(', '),
          offerStart: initial.offerStart ? initial.offerStart.slice(0, 10) : '',
          offerEnd: initial.offerEnd ? initial.offerEnd.slice(0, 10) : '',
        }
      : EMPTY
  );
  const [saving, setSaving] = useState(false);
  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.productName.trim()) return;
    setSaving(true);
    try {
      await onSave({
        ...form,
        price: Number(form.price) || 0,
        offerPrice: form.offerPrice === '' ? null : Number(form.offerPrice),
        tags: form.tags.split(',').map((s) => s.trim()).filter(Boolean),
        keywords: form.keywords.split(',').map((s) => s.trim()).filter(Boolean),
        offerStart: form.offerStart || null,
        offerEnd: form.offerEnd || null,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center" onClick={onClose}>
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full sm:max-w-xl max-h-[92vh] overflow-y-auto bg-[#14141C] ring-1 ring-white/10 rounded-t-3xl sm:rounded-3xl p-6 shadow-2xl shadow-black/50"
      >
        <div className="flex items-center justify-between mb-5">
          <h3 className="text-lg font-bold tracking-tight">{initial ? 'Edit Product' : 'Add Product'}</h3>
          <button onClick={onClose} className="text-white/40 hover:text-white text-xl leading-none">✕</button>
        </div>

        <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <label className={`${labelCls} sm:col-span-2`}>Product Name * <input className={inputCls} value={form.productName} onChange={set('productName')} required /></label>
          <label className={labelCls}>Category <input className={inputCls} value={form.category} onChange={set('category')} /></label>
          <label className={labelCls}>Sub Category <input className={inputCls} value={form.subCategory} onChange={set('subCategory')} /></label>
          <label className={`${labelCls} sm:col-span-2`}>Description <textarea rows={2} className={inputCls} value={form.description} onChange={set('description')} /></label>
          <label className={labelCls}>Unit <input className={inputCls} value={form.unit} onChange={set('unit')} placeholder="e.g. per kg, per session" /></label>
          <label className={labelCls}>
            Availability
            <select className={inputCls} value={form.availability} onChange={set('availability')}>
              {AVAILABILITY.map((a) => <option key={a} value={a} className="bg-[#14141C]">{a}</option>)}
            </select>
          </label>
          <label className={labelCls}>Price (₹) * <input type="number" className={inputCls} value={form.price} onChange={set('price')} required /></label>
          <label className={labelCls}>Offer Price (₹) <input type="number" className={inputCls} value={form.offerPrice} onChange={set('offerPrice')} placeholder="leave blank if none" /></label>

          <label className={labelCls}>
            Offer Type
            <select className={inputCls} value={form.offerLabel} onChange={set('offerLabel')}>
              {OFFER_LABELS.map((o) => <option key={o} value={o} className="bg-[#14141C]">{o || 'No offer'}</option>)}
            </select>
          </label>
          <div className="grid grid-cols-2 gap-2">
            <label className={labelCls}>Offer Start <input type="date" className={inputCls} value={form.offerStart} onChange={set('offerStart')} /></label>
            <label className={labelCls}>Offer End <input type="date" className={inputCls} value={form.offerEnd} onChange={set('offerEnd')} /></label>
          </div>

          <label className={labelCls}>Tags <input className={inputCls} value={form.tags} onChange={set('tags')} placeholder="comma separated" /></label>
          <label className={labelCls}>Keywords <input className={inputCls} value={form.keywords} onChange={set('keywords')} placeholder="for search — e.g. keratin, laptop" /></label>

          <div className="sm:col-span-2 flex justify-end gap-3 mt-2">
            <button type="button" onClick={onClose} className="px-4 py-2.5 rounded-xl text-sm font-medium bg-white/5 text-white/70 ring-1 ring-white/10 hover:bg-white/10 transition">
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving}
              className="px-5 py-2.5 rounded-xl text-sm font-semibold text-white bg-gradient-to-r from-cyan-500 to-emerald-500
                         hover:from-cyan-400 hover:to-emerald-400 shadow-lg shadow-emerald-900/30 disabled:opacity-50 transition"
            >
              {saving ? 'Saving…' : 'Save Product'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
